




export const firebaseConfig = {
    apiKey: "AIzaSyBTutq5XtOWToxGbJi7FCEhanuL9MsRo-g",
    authDomain: "f8lyss-music-app-63fb7.firebaseapp.com",
    projectId: "f8lyss-music-app-63fb7",
    storageBucket: "f8lyss-music-app-63fb7.firebasestorage.app",
    messagingSenderId: "929908237628",
    appId: "1:929908237628:web:862be07a913bfd4b71ea39"
};

// VAPID public key from Firebase Console > Project Settings > Cloud Messaging > Web Push certificates
export const vapidKey = "BLaeUcg0jnlshXPLUvICEV8WRg8XnQtqC96ycrhEkGLWZHa8MzlX0vrFpyTSk2gZJ1jVUsvXvBvwxwK26NEpusI";